import { useOutletContext, useParams } from 'react-router-dom';
import { StatusLabel } from '@shared/components/StatusLabel';
import { TERMINOLOGY } from '@shared/i18n/terminology';
import { EmbeddedDocument } from '@modules/documents';
import { useRefetchChangeTemplateAfterSave } from '../api';
import type { TChangeTemplateOutletContext } from '../types';

// The request or one assessment, inside the editor session that the page holds.
const ChangeTemplateDocumentSection = () => {
  const { details, selected, document, documentError } = useOutletContext<TChangeTemplateOutletContext>();
  const { assessmentId } = useParams<{ assessmentId?: string }>();
  useRefetchChangeTemplateAfterSave(details.changeTemplate._id);

  // Removed from the draft, or missing from the selected version: gone, like an archived template, with its own message.
  if (assessmentId && !selected.assessments.some((assessment) => assessment._id === assessmentId))
    return <StatusLabel data={null} error errorMessage="This assessment is not available." />;

  return (
    <StatusLabel
      data={document}
      error={documentError}
      loadingMessage={`Loading the ${TERMINOLOGY.changeTemplate.lower} document...`}
      errorMessage={`Loading the ${TERMINOLOGY.changeTemplate.lower} document failed!`}
      render={() => <EmbeddedDocument />}
    />
  );
};

export default ChangeTemplateDocumentSection;
